<template>
  <div class="csDevice">
    <div class="select">
      <table>
        <tr>
          <td>代理姓名：
            <el-input v-model="csName"></el-input>
          </td>
          <td>代理电话：
            <el-input v-model="csName"></el-input>
          </td>
          <td>
            <el-button icon="el-icon-search" style="background-color: #FF9000; color: #FFFFFF">搜索</el-button>
            <el-button icon="el-icon-delete" type="info">搜索</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-table
        :data="csList"
        border
        style="width: 100%">
        <el-table-column
          prop="date"
          label="代理姓名"
          align="center">
          <el-button type="text" @click="csDevice = true">张三</el-button>
        </el-table-column>
        <el-table-column
          prop="name"
          label="代理联系方式"
          align="center">
          18784769341
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="400">
      </el-pagination>
    </div>
    <div class="detail">
      <el-drawer
        :visible.sync="csDevice"
        :with-header="false"
        direction="rtl"
        size="50%">
        <div class="title">
          <div class="titleImg">
            <img :src="titleImg" width="100%" height="100%" alt=""/>
          </div>
          <div class="orderId">
            <span style="font-size: 16px;">代理姓名：张三</span>
          </div>
        </div>
        <div class="deviceList">
          <div class="deviceTable">
            <table>
              <tr>
                <td>设备编号：
                  <el-input v-model="deviceCode"></el-input>
                </td>
                <td>设备类型：
                  <el-select v-model="deviceTypevalue" placeholder="设备类型">
                    <el-option
                      v-for="item in deviceTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <el-button icon="el-icon-search" style="background-color: #FF9000; color: #FFFFFF;">搜索</el-button>
                  <el-button icon="el-icon-delete" type="info">搜索</el-button>
                </td>
              </tr>
            </table>
          </div>
          <el-table
            :data="deviceData"
            border
            style="width: 100%">
            <el-table-column
              prop="warehouse"
              label="仓库名称"
              align="center">
            </el-table-column>
            <el-table-column
              prop="deviceCode"
              label="设备编号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="deviceType"
              label="设备类型"
              align="center">
            </el-table-column>
            <el-table-column
              prop="supplier"
              label="设备供应商"
              align="center">
            </el-table-column>
            <el-table-column
              prop="devicestate"
              label="状态"
              align="center">
            </el-table-column>
            <el-table-column
              prop="time"
              label="操作时间"
              align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="block" style="float: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="prev, pager, next"
            :total="400">
          </el-pagination>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsDevice',
  data() {
    return {
      titleImg: require('../../../../static/image/powerbankorder/bianji.png'),
      csDevice: false,
      csList: [{}],
      deviceTypeOptions: [{
        value: '1',
        label: '6口设备'
      },
        {
          value: '2',
          label: '9口设备'
        }]
    }
  }
}
</script>

<style scoped>
.csDevice {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.data {
  width: 100%;
  height: 70%;
}

.select {
  width: 100%;
  height: 11%;
  padding: 10px;
}

.select .el-input {
  width: 60%;
}

.select table {
  text-align: left;
  font-size: 16px;
  width: 60%;
}

.select table tr td {
  width: 30%;
}

.data {
  width: 60%;
  height: 80%;
  margin: auto;

}

.deviceList {
  padding: 10px;
  width: 100%;
  height: 85%;
}

.titleImg {
  width: 40px;
  height: 40px;
}

.titleImg img {
  display: block;
  float: left;
  margin: 10px 20px;
}

.orderId {
  float: left;
  margin-top: -20px;
  margin-left: -10px;
}

/deep/ :focus {
  outline: none;
}

.orderDetail table {
  display: block;
  text-align: left;
  float: left;
  margin-top: 10px;
  margin-left: -125px;
  font-size: 16px;
}

.tag table {
  text-align: left;
  width: 80%;
}

.tag table tr td {
  width: 60%;
}

.title {
  height: 7%;
  background-color: #FF9000;
}

.deviceTable {
  margin: 30px 10px;
  width: 100%;
}

.deviceTable table .el-input {
  width: 60%;
}

.deviceTable table {
  float: left;
  text-align: left;
  font-size: 16px;
  width: 100%;
}

.deviceTable table tr td {
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/mywarehouse/csdevice.vue